import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const AdminSidebar = ({ isCollapsed = false, onToggleCollapse, userName = 'Admin', userRole = 'Yönetici' }) => {
  const location = useLocation();
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const navigationItems = [
    {
      label: 'Kontrol Paneli',
      path: '/admin-dashboard',
      icon: 'LayoutDashboard',
      tooltip: 'Ana kontrol paneli'
    },
    {
      label: 'Rota Yönetimi',
      path: '/routes-management',
      icon: 'Route',
      tooltip: 'Rota bilgilerini düzenle'
    },
    {
      label: 'Güzergah Geometrisi',
      path: '/route-geometry-management',
      icon: 'Map',
      tooltip: 'Harita üzerinde rota çiz'
    },
    {
      label: 'Program Yönetimi',
      path: '/schedules-management',
      icon: 'Clock',
      tooltip: 'Sefer saatlerini düzenle'
    }
  ];

  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  const handleMobileToggle = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  const handleLinkClick = () => {
    setIsMobileOpen(false);
  };

  return (
    <>
      <button
        onClick={handleMobileToggle}
        className="lg:hidden fixed top-4 left-4 z-50 flex items-center justify-center w-12 h-12 bg-card rounded-lg shadow-md transition-smooth active-press"
        aria-label="Menü"
      >
        <Icon name={isMobileOpen ? "X" : "Menu"} size={24} color="var(--color-foreground)" />
      </button>
      <aside
        className={`fixed lg:fixed top-0 left-0 h-full bg-card border-r border-border z-100 transition-smooth ${
          isCollapsed ? 'w-20' : 'w-64'
        } ${isMobileOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}
      >
        <div className="flex flex-col h-full">
          <div className="admin-sidebar-header flex items-center justify-between h-16 px-4 border-b border-border">
            <div className={`admin-sidebar-logo flex items-center gap-3 transition-smooth ${isCollapsed ? 'justify-center' : ''}`}>
              <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg transition-smooth">
                <Icon name="Bus" size={24} color="var(--color-primary)" />
              </div>
              {!isCollapsed && (
                <span className="text-lg font-bold text-foreground font-heading">
                  Dolmuş Admin
                </span>
              )}
            </div>
            <button
              onClick={onToggleCollapse}
              className="hidden lg:flex items-center justify-center w-8 h-8 rounded-lg hover:bg-muted transition-smooth active-press"
              aria-label={isCollapsed ? 'Genişlet' : 'Daralt'}
            >
              <Icon name={isCollapsed ? "ChevronRight" : "ChevronLeft"} size={20} color="var(--color-foreground)" />
            </button>
          </div>

          <nav className="flex-1 overflow-y-auto py-4 px-2">
            <ul className="space-y-1">
              {navigationItems?.map((item) => {
                const isActive = isActivePath(item?.path);
                return (
                  <li key={item?.path}>
                    <Link
                      to={item?.path}
                      onClick={handleLinkClick}
                      className={`flex items-center gap-3 px-3 py-3 rounded-lg transition-smooth hover-lift ${
                        isActive
                          ? 'bg-primary text-primary-foreground'
                          : 'text-foreground hover:bg-muted'
                      } ${isCollapsed ? 'justify-center' : ''}`}
                      title={isCollapsed ? item?.tooltip : ''}
                    >
                      <Icon
                        name={item?.icon}
                        size={20}
                        color={isActive ? 'var(--color-primary-foreground)' : 'var(--color-foreground)'}
                      />
                      {!isCollapsed && (
                        <span className="font-medium text-sm">{item?.label}</span>
                      )}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>

          <div className="border-t border-border p-4">
            <div className={`flex items-center gap-3 ${isCollapsed ? 'justify-center' : ''}`}>
              <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-full">
                <Icon name="User" size={20} color="var(--color-primary)" />
              </div>
              {!isCollapsed && (
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground truncate">{userName}</p>
                  <p className="text-xs text-muted-foreground truncate">{userRole}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </aside>
      {isMobileOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-background z-50"
          onClick={handleMobileToggle}
        />
      )}
    </>
  );
};

export default AdminSidebar;